import { render, staticRenderFns } from "./DetalhesAnaliseJustificativaDialog.vue?vue&type=template&id=71821fa9&scoped=true"
import script from "./DetalhesAnaliseJustificativaDialog.vue?vue&type=script&lang=js"
export * from "./DetalhesAnaliseJustificativaDialog.vue?vue&type=script&lang=js"
import style0 from "./DetalhesAnaliseJustificativaDialog.vue?vue&type=style&index=0&id=71821fa9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71821fa9",
  null
  
)

export default component.exports